w<!-- ==========================================================================================
    File Name: Create.vue
    Description: Create Customers Page
========================================================================================== -->

<template>
        <div id="create-customers-page">
                <vx-card>
                        <!-- Personal Data -->
                        <div class="vx-row leading-loose mt-3">
                                <div class="vx-col w-full md:w-1/2">
                                        <h4>Datos del Vehiculo</h4>
                                </div>
                        </div>
                        <vs-row vs-w="12">
                                <vs-col
                                        vs-align="center"
                                        vs-justify="center"
                                        vs-lg="2"
                                        vs-sm="12"
                                        vs-type="flex"
                                        vs-xs="12"
                                >
                                        <vs-upload
                                                v-if="vehicleData.owner"
                                                :headers="headers"
                                                action="/api/user/update/vehicle/photo"
                                                file-name="pet"
                                                limit="1"
                                                :data="{ owner: vehicleData.owner }"
                                                automatic
                                                show-upload-button
                                                text="Subir foto"
                                                text-max="Se han alcanzado el limite de archivos"
                                                @on-success="successUpload"
                                        />
                                </vs-col>
                                <vs-col vs-lg="10" vs-sm="12" vs-xs="12">
                                        <!-- Row -->
                                        <div class="vx-row leading-loose mt-3">
                                                <div class="vx-col w-full md:w-1/3">
                                                        <vs-select
                                                                v-model="vehicleData.owner"
                                                                v-validate="'required'"
                                                                class="w-full select-large"
                                                                label="Dueño del Vehiculo"
                                                                name="owner"
                                                                no-data="No hay datos que mostrar"
                                                        >
                                                                <vs-select-item
                                                                        v-for="(item, index) in customers"
                                                                        :key="index"
                                                                        :text="
                                                                                `${item.unidad.nombre_bloque} ${item.unidad.nombre_unidad} `
                                                                        "
                                                                        :value="item.id"
                                                                />
                                                        </vs-select>
                                                        <span
                                                                v-show="errors.has('owner')"
                                                                class="text-danger text-sm"
                                                                >{{ errors.first('owner') }}</span
                                                        >
                                                </div>
                                                <div class="vx-col w-full md:w-1/3">
                                                        <vs-select
                                                                v-model="vehicleData.marca"
                                                                v-validate="'required'"
                                                                class="w-full select-large"
                                                                label="Marca"
                                                                name="marca"
                                                                autocomplete
                                                                no-data="No hay datos que mostrar"
                                                        >
                                                                <vs-select-item
                                                                        v-for="(item, index) in marcas"
                                                                        :key="index"
                                                                        :text="item.text"
                                                                        :value="item.value"
                                                                />
                                                        </vs-select>
                                                        <span
                                                                v-show="errors.has('marca')"
                                                                class="text-danger text-sm"
                                                                >{{ errors.first('marca') }}</span
                                                        >
                                                </div>
                                                <div class="vx-col w-full md:w-1/3">
                                                        <vs-input
                                                                v-model="vehicleData.modelo"
                                                                v-validate="'required'"
                                                                name="modelo"
                                                                label="Modelo"
                                                                class="w-full no-icon-border"
                                                        />
                                                        <span
                                                                v-show="errors.has('modelo')"
                                                                class="text-danger text-sm"
                                                                >{{ errors.first('modelo') }}</span
                                                        >
                                                </div>
                                        </div>
                                        <!-- end row -->
                                        <!-- Row -->
                                        <div class="vx-row leading-loose mt-3">
                                                <div class="vx-col w-full md:w-1/3">
                                                        <vs-input
                                                                v-model="vehicleData.año"
                                                                v-validate="'required|numeric'"
                                                                name="año"
                                                                label="Año"
                                                                class="w-full no-icon-border"
                                                        />
                                                        <span v-show="errors.has('año')" class="text-danger text-sm">{{
                                                                errors.first('año')
                                                        }}</span>
                                                </div>
                                                <div class="vx-col w-full md:w-1/3">
                                                        <vs-input
                                                                v-model="vehicleData.color"
                                                                v-validate="'required'"
                                                                name="Color"
                                                                label="color"
                                                                class="w-full no-icon-border"
                                                        />
                                                        <span
                                                                v-show="errors.has('color')"
                                                                class="text-danger text-sm"
                                                                >{{ errors.first('color') }}</span
                                                        >
                                                </div>
                                                <div class="vx-col w-full md:w-1/3">
                                                        <vs-input
                                                                v-model="vehicleData.placas"
                                                                v-validate="'required'"
                                                                name="placas"
                                                                label="Placas"
                                                                class="w-full no-icon-border"
                                                        />
                                                        <span
                                                                v-show="errors.has('placas')"
                                                                class="text-danger text-sm"
                                                                >{{ errors.first('placas') }}</span
                                                        >
                                                </div>
                                        </div>
                                        <!-- end row -->
                                </vs-col>
                        </vs-row>

                        <!-- start row -->
                        <vs-row vs-type="flex" vs-justify="flex-end" class="mt-10" vs-w="12">
                                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="12">
                                        <vs-button
                                                color="primary"
                                                type="filled"
                                                icon-pack="FA5"
                                                icon="far fa-save"
                                                @click="createVehicle()"
                                                >Agregar vehículo</vs-button
                                        >
                                </vs-col>
                        </vs-row>
                        <!-- end row -->
                        <!-- end Personal Data -->
                </vx-card>
        </div>
</template>

<script>
import { mapState } from 'vuex';
import AwesomeMask from 'awesome-mask';

import { Validator } from 'vee-validate';
const dict = {
        custom: {
                marca: {
                        required: 'Este campo es requerido',
                },
                modelo: {
                        required: 'Este campo es requerido',
                },
                año: {
                        numeric: 'En este campo solo se permiten numeros',
                        required: 'Este campo es requerido',
                },
                color: {
                        required: 'Este campo es requerido',
                },
                placas: {
                        required: 'Este campo es requerido',
                },
        },
};
// register custom messages
Validator.localize('en', dict);

export default {
        data() {
                return {
                        vehicleData: {
                                owner: '',
                                marca: '',
                                modelo: '',
                                año: '',
                                color: '',
                                placas: '',
                        },

                        marcas: [
                                { text: 'Alfa Romeo', value: 'alfa-romeo' },
                                { text: 'Aro', value: 'aro' },
                                { text: 'Asia', value: 'asia' },
                                { text: 'Astron Martin', value: 'astron-martin' },
                                { text: 'Audi', value: 'audi' },
                                { text: 'BMW', value: 'bmw' },
                                { text: 'BYD', value: 'byd' },
                                { text: 'Baic', value: 'baic' },
                                { text: 'Brilliance', value: 'brilliance' },
                                { text: 'Buick', value: 'buick' },
                                { text: 'Cadillac', value: 'cadillac' },
                                { text: 'Chana', value: 'chana' },
                                { text: 'Changan', value: 'changan' },
                                { text: 'Changhe', value: 'changhe' },
                                { text: 'Chery', value: 'chery' },
                                { text: 'Chevrolet', value: 'chevrolet' },
                                { text: 'Chrysler', value: 'chrysler' },
                                { text: 'Citroën', value: 'citroën' },
                                { text: 'DFSK', value: 'dfsk' },
                                { text: 'DFM/DS', value: 'dfm/ds' },
                                { text: 'Critroën', value: 'critroën' },
                                { text: 'Daewoo', value: 'daewoo' },
                                { text: 'Daihatsu', value: 'daihatsu' },
                                { text: 'Dodge', value: 'dodge' },
                                { text: 'FAW', value: 'faw' },
                                { text: 'Fiat', value: 'fiat' },
                                { text: 'Ford', value: 'ford' },
                                { text: 'Foton', value: 'foton' },
                                { text: 'GMC', value: 'gmc' },
                                { text: 'Geely', value: 'geely' },
                                { text: 'Gonow', value: 'gonow' },
                                { text: 'Hafei', value: 'hafei' },
                                { text: 'Haima', value: 'haima' },
                                { text: 'Haval', value: 'haval' },
                                { text: 'Higer', value: 'higer' },
                                { text: 'Hino', value: 'Hino' },
                                { text: 'Honda', value: 'honda' },
                                { text: 'Hummer', value: 'hummer' },
                                { text: 'Infiniti', value: 'infiniti' },
                                { text: 'Iveco', value: 'iveco' },
                                { text: 'JAC', value: 'jAC' },
                                { text: 'Jaguar', value: 'jaguar' },
                                { text: 'Jeep', value: 'jeep' },
                                { text: 'Jmc', value: 'jmc' },
                                { text: 'Kia', value: 'kia' },
                                { text: 'Lada', value: 'lada' },
                                { text: 'Lancia', value: 'lancia' },
                                { text: 'Land Rover', value: 'land-rover' },
                                { text: 'Landwind', value: 'landwind' },
                                { text: 'Lexus', value: 'lexus' },
                                { text: 'Lincoln', value: 'lincoln' },
                                { text: 'MG', value: 'mG' },
                                { text: 'Maserati', value: 'maserati' },
                                { text: 'Mazda', value: 'mazda' },
                                { text: 'Mercedes Benz', value: 'mercedes-benz' },
                                { text: 'Mini', value: 'mini' },
                                { text: 'Mitsubishi', value: 'mitsubishi' },
                                { text: 'Nissan', value: 'nissan' },
                                { text: 'Otras Marcas', value: 'otras-marcas' },
                                { text: 'Peugeot', value: 'peugeot' },
                                { text: 'Plymouth', value: 'plymouth' },
                                { text: 'Pontiac', value: 'pontiac' },
                                { text: 'Porsche', value: 'porsche' },
                                { text: 'RAM', value: 'ram' },
                                { text: 'Renault', value: 'renault' },
                                { text: 'Rover', value: 'rover' },
                                { text: 'Seat', value: 'seat' },
                                { text: 'Skoda', value: 'skoda' },
                                { text: 'Ssangyong', value: 'ssangyong' },
                                { text: 'Subaru', value: 'subaru' },
                                { text: 'Suzuki', value: 'suzuki' },
                                { text: 'Tesla', value: 'tesla' },
                                { text: 'Toyota', value: 'toyota' },
                                { text: 'Volkswagen', value: 'volkswagen' },
                                { text: 'Volvo', value: 'volvo' },
                                { text: 'Wuling', value: 'wuling' },
                                { text: 'Zhongxing', value: 'zhongxing' },
                                { text: 'Zotye', value: 'zotye' },
                        ],
                        headers: {
                                Authorization: `Bearer ${this.$store.state.authToken}`,
                        },
                };
        },
        computed: {
                ...mapState(['customers']),
                updateOwner: function() {
                        return this.data.owner;
                },
        },
        methods: {
                successUpload() {
                        this.$vs.notify({
                                color: 'success',
                                title: 'Imagen actualizada',
                                text: '',
                        });
                },
                createVehicle() {
                        this.$validator.validateAll().then(result => {
                                if (result) {
                                        this.$store
                                                .dispatch('createVehicle', this.vehicleData)
                                                .then(res => {
                                                        console.log(res);
                                                        this.openAlert('success', res.message);
                                                        this.$router.push({ name: 'listUsers' });
                                                })
                                                .catch(err => console.log(err.message));
                                }
                        });
                },
                openAlert(color, message) {
                        this.colorAlert = color || this.getColorRandom();
                        this.$vs.dialog({
                                color: this.colorAlert,
                                title: 'Aviso',
                                text:
                                        this.colorAlert === 'danger'
                                                ? ' Ocurrio un error, por favor contacta al administrador'
                                                : message,
                                accept: this.acceptAlert,
                        });
                },
                acceptAlert() {
                        this.$vs.notify({
                                color: this.colorAlert,
                                title: 'Aviso',
                                text:
                                        this.colorAlert === 'danger'
                                                ? ' Por favor revisa todos los campos'
                                                : 'Continuemos',
                        });
                },
        },
        components: {},
};
</script>
